/* eslint-disable @typescript-eslint/no-explicit-any */
import { Accordion } from "components/ui/accordion";
import { AccordionException } from "./accordion-exception/accordion-exception";
import { InfoValues } from "./accordion-exception/info-values";

export function ModalDetailsException({ requestData }: { requestData: any }) {
  return (
    <div className="space-y-6">
      <div className="pb-4 border-b border-gray-200">
        <h2 className="text-2xl font-bold text-gray-900">
          Detalhes da Exceção
        </h2>
      </div>
      
      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-6 shadow-sm border border-blue-100">
        <InfoValues requestData={requestData} />
      </div>
      
      <Accordion type="multiple" className="space-y-3">
        {requestData?.value_history_exception?.length > 0 && (
          <AccordionException
            data={requestData.value_history_exception}
            typeRequest={requestData.type_request}
          />
        )}
      </Accordion>
    </div>
  );
}
